import * as React from 'react';

function SvgReferAndEarn(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M13.588 14.854a6.141 6.141 0 00-1.29-.689 3.292 3.292 0 001.07-2.171 4.868 4.868 0 016.173-.505.647.647 0 10.74-1.061 6.147 6.147 0 00-1.29-.689 3.3 3.3 0 10-4.441-.007q-.135.052-.269.111a6.142 6.142 0 00-1.139.657 3.3 3.3 0 10-5.291 3.656 6.22 6.22 0 00-3.754 3.866 1.94 1.94 0 001.847 2.535h5.624a.647.647 0 000-1.294H5.942a.647.647 0 01-.616-.845 4.99 4.99 0 014.741-3.375 4.838 4.838 0 012.781.872.647.647 0 10.74-1.061zm3.187-9.56a2 2 0 11-2 2 2.007 2.007 0 012-2zM10.081 9.72a2 2 0 11-2 2 2.007 2.007 0 012-2zm10.477 7.765a.647.647 0 01-.647.647h-1.778v1.778a.647.647 0 11-1.294 0v-1.778h-1.778a.647.647 0 010-1.294h1.778V15.06a.647.647 0 011.294 0v1.778h1.778a.647.647 0 01.647.647zm0 0"
        fill={props.fill}
      />
    </svg>
  );
}

export default SvgReferAndEarn;
